import { EBookingStatus, EExamStatus } from '../enums'
import { IOptionItem } from 'interfaces'

export const C_BOOKING_FILTERS: Array<IOptionItem> = [
  {
    value: {
      status: [
        EBookingStatus.Created,
        EBookingStatus.Canceled,
        EBookingStatus.Confirmed,
        EBookingStatus.InProgress,
        EBookingStatus.Finished
      ]
    },
    label: 'all',
    field: 'total'
  },
  {
    value: {
      status: [EBookingStatus.Created]
    },
    label: 'create-new',
    field: 'create-new'
  },
  {
    value: {
      status: [EBookingStatus.Confirmed]
    },
    label: 'confirmed',
    field: 'confirmed'
  },
  {
    value: {
      status: [EBookingStatus.InProgress]
    },
    label: 'in-progressing',
    field: 'inProgress'
  },
  {
    value: {
      status: [EBookingStatus.Finished]
    },
    label: 'complete',
    field: 'finished'
  },

  {
    value: {
      status: [EBookingStatus.Canceled]
    },
    label: 'reject',
    field: 'reject'
  }
]

export const C_EXAM_FILTERS: Array<IOptionItem> = [
  {
    value: {
      exam_status: [
        EExamStatus.UnKnow,
        EExamStatus.Confirmed,
        EExamStatus.Waiting,
        EExamStatus.DataCollection,
        EExamStatus.InProgress,
        EExamStatus.Finished,
        EExamStatus.Canceled
      ],
      status: [EBookingStatus.InProgress, EBookingStatus.Finished]
    },
    label: 'all',
    field: 'total'
  },
  {
    value: {
      exam_status: [EExamStatus.Waiting],
      status: [EBookingStatus.InProgress, EBookingStatus.Finished]
    },
    label: 'waiting-examination',
    field: 'waiting'
  },
  {
    value: {
      exam_status: [EExamStatus.InProgress],
      status: [EBookingStatus.InProgress, EBookingStatus.Finished]
    },
    label: 'being-examined',
    field: 'in_progress'
  },
  {
    value: {
      exam_status: [EExamStatus.DataCollection],
      status: [EBookingStatus.InProgress, EBookingStatus.Finished]
    },
    label: 'data-collection',
    field: 'data_collection'
  },
  {
    value: {
      exam_status: [EExamStatus.Finished],
      status: [EBookingStatus.InProgress, EBookingStatus.Finished]
    },
    label: 'examed',
    field: 'finished'
  },
  {
    value: {
      exam_status: [EExamStatus.Canceled],
      status: [EBookingStatus.InProgress, EBookingStatus.Finished]
    },
    label: 'doctor-reject',
    field: 'canceled'
  }
]

export const C_PATIENT_FILTERS: Array<IOptionItem> = [
  {
    value: [],
    label: 'all',
    field: 'total'
  }
]

export const FILTER_BOOKING_OPTIONS: Array<IOptionItem> = [
  {
    label: 'fullname',
    value: 0
  },
  {
    label: 'status-active-1',
    value: 1
  }
]
